




















































































































































import { Getter, Action, Mutation } from "vuex-class";
import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import { Loader, FormSelect } from "@/components/forms";
import CanRedirectAfterIpSettingsChange from "@/mixins/can-redirect-after-ip-settings-change";
import { Feature } from "@/enums";

@Component({
  components: {
    Loader,
    FormSelect,
    VisualNode: () => import("./components/visual/node.vue"),
    LayoutModal: () => import("@/components/layouts/modal.vue"),
  },
})
export default class AppBase extends Mixins(CanRedirectAfterIpSettingsChange) {
  @Getter("device/configMode") configMode!: string;

  @Getter("device/model") deviceModel!: string;

  @Getter("device/name") deviceName!: string;

  @Getter("device/hasEinkDisplay") deviceHasEink!: boolean;

  @Getter("power/information") powerInformation!: PowerInformation;

  @Getter("feature/active") features!: Array<Feature>;

  @Getter("feature/supported") supported_features!: Array<Feature>;

  @Getter("port/all") ports!: Port[];

  @Getter("poe/ports") poePorts!: PoEPort[];

  @Getter("group/all") groups!: Group[];

  @Getter("trunk/all") trunks!: Trunk[];

  @Getter("pageLoading") pageLoading!: boolean;

  @Getter("device/model") model!: string;

  @Getter("profile/name") profileName!: string;

  @Getter("websocket/getEventData") socketEventData!: any;

  @Action("websocket/connect") connectToSocket!: ConnectToSocket;

  @Action("websocket/disconnect") cisconnectFromSocket!: DisconnectFromSocket;

  @Action("device/identify") identify!: Identify;

  @Action("websocket/subscribeStatusPage") subscribeStatusPage!: SubscribeStatusPage;

  @Action("websocket/unSubscribeStatusPage") unSubscribeStatusPage!: UnSubscribeStatusPage;

  @Mutation("poe/SET_STATISTICS") setPoeStats!: any;

  @Mutation("poe/SET_PORTS") setPoePorts!: any;

  @Mutation("port/SET_MODELS") setPorts!: any;

  @Mutation("port/SET_LAGS") setLags!: any;

  @Mutation("group/SET_MODELS") setGroups!: any;

  @Mutation("trunk/SET_MODELS") setTrunks!: any;

  @Mutation("profile/SET_NAME") setProfileName!: any;

  @Mutation("power/SET_POWER_INFORMATION") setPowerInformation!: any;

  @Mutation("device/SET_DEVICE_IP_SETTINGS") setIpSettings!: any;

  @Mutation("device/SET_DEVICE_MDNS") setMdns!: any;

  @Mutation("port/SET_RLINKX_PORTS_MODELS") setRlinksPorts!: any;

  @Ref("visualNode") visualNode!: any;

  connectingToSocket = false;

  sidebarOpen = true;

  identifying = false;

  identified = false;

  showUpdatingFirmware = false;

  lang = "en";

  theme = "dark";

  languages = [
    { label: this.$t("views.general.english"), value: "en" },
    { label: this.$t("views.general.japanese"), value: "jp" },
    { label: this.$t("views.general.chinese"), value: "cn" },
  ];

  async mounted() {
    this.colorMode();

    this.initWebsocket();

    let preffered_lang = localStorage.getItem(`${process.env.VUE_APP_NAME}_LANG`) || "en";
    this.lang = this.languages.find((l) => l.value === preffered_lang)?.value || "en";
  }

  async initWebsocket() {
    if (process.env.VUE_APP_WS_ENABLED === "false") {
      return;
    }

    await this.connectToSocket();

    await this.subscribeStatusPage();
  }

  colorMode() {
    // On page load or when changing themes, best to add inline in `head` to avoid FOUC
    if (localStorage.theme === "dark" || (!("theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
      document.documentElement.classList.add("dark");
      this.theme = "dark";
    } else {
      document.documentElement.classList.remove("dark");
      this.theme = "light";
    }
  }

  setLightMode() {
    localStorage.theme = "light";
    this.theme = "light";
    window.location.reload();
  }

  setDarkMode() {
    localStorage.theme = "dark";
    this.theme = "dark";
    window.location.reload();
  }

  toggleTheme() {
    if (this.theme === "dark") {
      this.setLightMode();
    } else {
      this.setDarkMode();
    }
  }

  handleUpdaetLang() {
    this.$i18n.locale = this.lang;
    localStorage.setItem(`${process.env.VUE_APP_NAME}_LANG`, this.lang);
    window.location.reload();
  }

  private handleIdentify() {
    this.identifying = true;
    this.identify().then(() => {
      this.identifying = false;
      this.identified = true;
      setTimeout(() => {
        this.identified = false;
      }, 2000);
    });
  }

  @Watch("socketEventData")
  handleEventDataChanged(eventData: any) {
    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/device/name`) {
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/power`) {
      this.setPowerInformation(eventData.api_notification.new_value);
    }
    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/config/name`) {
      this.setProfileName(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/poe`) {
      this.setPoeStats(eventData.api_notification.new_value);
      this.setPoePorts(eventData.api_notification.new_value.ports);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/ports/port`) {
      // @ts-ignore
      if (!(this.$root.selectedGroup || this.$root.selectedTrunk)) {
        this.setPorts(eventData.api_notification.new_value);
      }
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/ports/lags/lag`) {
        this.setLags(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/groups/group`) {
      this.setGroups(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/trunks/trunk`) {
      this.setTrunks(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/ip_settings`) {
      this.maybeRedirectAfterIpSettingsChange(eventData.api_notification.new_value.ip_address);

      this.setIpSettings(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/mdns`) {
      this.setMdns(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/rlinkx/ports`) {
      this.setRlinksPorts(eventData.api_notification.new_value);
    }

    if (eventData.api_notification && eventData.api_notification.path && eventData.api_notification.path === `/api/eink/eink_cmd_buffer`) {
      // @ts-ignore
      this.visualNode.reloadImage();
    }
  }

  get deviceType(): string {
    if (!this.model) {
      return "";
    }

    return this.model;
  }
}
